import { ModelCompare } from "components/ModelCompare";
import { ButtonGroup } from "components/ModelCompare/ProductList/components/ButtonGroup";
import React from "react";
import { ModelCompareWithButtonGroupProps } from "./ModelCompareWithButtonGroup.types";
import { MODEL_COMPARE_STICK_OFFSET_CORRECTION } from "util/constants";

export const ModelCompareWithButtonGroup = ({
  tabItems,
  activeTab,
  onTabClick,
  externalSelectedProducts,
  externalSetSelectedProducts,
  showBuyButton,
  section,
}: ModelCompareWithButtonGroupProps) => {
  return (
    <>
      {!!tabItems.length && (
        <ButtonGroup
          items={tabItems}
          onClick={onTabClick}
          activeButton={activeTab}
        />
      )}
      <ModelCompare
        showBuyButton={showBuyButton ?? false}
        section={{ ...section, showProductGroups: !tabItems.length }}
        headerStickOffset={({ maxImageHeight }) =>
          maxImageHeight + MODEL_COMPARE_STICK_OFFSET_CORRECTION
        }
        selectedProducts={externalSelectedProducts}
        setSelectedProducts={externalSetSelectedProducts}
      />
    </>
  );
};
